// eslint-disable-next-line no-unused-vars
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import cn from 'comma-number'

// import { Element } from 'react-scroll'

// import SvgIcon from 'Components/SvgIcon'
import AppButton from 'Components/AppButton'
import ComparableArchivedListings from 'Components/ComparableArchivedListings'

// import Demographics from 'Components/Demographics/DemographicsApiContainer'
import Collapsible from 'Components/Collapsible'
import EstimateAnimation from 'Components/EstimateAnimation'
// import PreviewSliderSection from 'Components/PreviewSliderSection'
// import { PROPERTY_TYPE_PLURAL } from 'Config/config'
import { SL_GATE } from 'Defaults/modals'
import ToolTipV2 from 'Components/ToolTipV2'
// import { computeEstimateStats } from './utils'

import {
  _EstimateContent, _EstimateRow, _EstimateBlock, _BoxTitle, _EstimatedNumber,
  _InsufficientTitle, _EstimateLoginCta, _BoxSubtitle,

  _StatBar,
  // _SubsectionTitle, _AvgStats, _InsufficientDataCta, _MobileAInsufficientDataContact,
  // _AvgStatBlock,
  // _StatBlockTitle, _StatBlockValue, _StatBlockSubtitle,
  // _ComaparableCta,
  _BlurCont,
} from './styles.js'


const ListingEstimate = ({
  googleAnalyticsEvent,
  listing,
  // openCollapseTargetId,
  collapsibleIdSuffix,
  // handleBookViewing,
  // handleContactAgentClick,
  // ctaSource,
  // agent,
  userIsAuthentificated,
  // isMobileApp,
  openLoginModal,
  openRegisterModal,
  // areasUrl,
  // navigationLinks,
}) => {
  if(!listing) return ''
  // const { title, name } = listing || {}

  const {
    prediction,
    // comparables,
  } = listing?.listing_estimate || {}

  // const {
  //   avgClosedPrice, avgListSellDiff, avgListSellDiffPercent, avgDom, totalDays, totalListings,
  // } = useMemo(() => computeEstimateStats(comparables)
  // , [comparables])


  // const searchUrl = `/${areasUrl || 'toronto'}/${PROPERTY_TYPE_PLURAL}-for-sale`
  // console.log(avgClosedPrice, avgListSellDiff, avgListSellDiffPercent, avgDom, totalDays, totalListings)

  const priceDiff = prediction ? prediction.expected - listing.asking_price : null
  // const priceDiffPercentage = priceDiff ? ((priceDiff / listing.asking_price) * 100).toFixed(1) : null

  const insufficientPredictionData = !prediction?.expected
  // const insufficientStatsData = !avgClosedPrice

  // const hideData = listing.hidden_fields?.estimation

  return (
    <Collapsible
      inputId={`Estimate-${collapsibleIdSuffix}`}
      title={'Home Value Estimate'}
      seoText={
        'View estimated sale price and comparable sold data'
      }
      gaActionTitle="Estimate"
      // openCollapseTargetId={openCollapseTargetId}
      defaultShowState
    >
      <_EstimateContent>

        <_EstimateRow>
          <_EstimateBlock>

            <_BoxTitle>
              <EstimateAnimation />
              <span>Instant estimate:</span>
            </_BoxTitle>

            {
              insufficientPredictionData ?
                <_InsufficientTitle>
                  Not Available
                  <p>Insufficient data to provide an accurate estimate</p>
                </_InsufficientTitle>
                :
                userIsAuthentificated ?
                  <_EstimatedNumber>
                    ${cn(prediction.expected)}
                  </_EstimatedNumber>
                  :
                  <_EstimateLoginCta>
                    <AppButton
                      textClickableBtn
                      onClick={() => {
                        openRegisterModal({
                          modalData: { gate: SL_GATE.ACTIVE_LISTING_ESTIMATE },
                        })
                        googleAnalyticsEvent({
                          category: 'listing',
                          action: '[Estimate section Register clicked]',
                        })
                      }}
                    >
                      Sign up
                    </AppButton>
                    or
                    <AppButton
                      textClickableBtn
                      onClick={() => {
                        openLoginModal({
                          modalData: { gate: SL_GATE.ACTIVE_LISTING_ESTIMATE },
                        })
                        googleAnalyticsEvent({
                          category: 'listing',
                          action: '[Estimate section Login clicked]',
                        })
                      }}
                    >
                      Log in
                    </AppButton>
                    to view instant estimate
                  </_EstimateLoginCta>

            }

            {
              !insufficientPredictionData &&
                <_BoxSubtitle>
                  <_BlurCont blur={!userIsAuthentificated}>
                    ${cn(Math.abs(priceDiff))}
                  </_BlurCont> {priceDiff > 0 ? 'higher' : 'lower'} than listed price
                </_BoxSubtitle>
            }

            <ToolTipV2
              title={'About our Instant Estimate'}
              body={
                'This listing\'s value estimate is powered by advanced algorithms and extensive real' +
                ' estate market data, providing you with a precise and data-driven market valuation.'
              }
              placement="left"
              parentIdSuffix={collapsibleIdSuffix}
            />
          </_EstimateBlock>

          <div>
            <_StatBar high>
              <span>High</span>
              {
                insufficientPredictionData ?
                  <span>-</span>
                  :
                  <span><_BlurCont blur={!userIsAuthentificated}>${cn(prediction.max)}</_BlurCont></span>
              }
            </_StatBar>
            <_StatBar >
              <span>Mid</span>
              {
                insufficientPredictionData ?
                  <span>-</span>
                  :
                  <span><_BlurCont blur={!userIsAuthentificated}>${cn(prediction.expected)}</_BlurCont></span>
              }
            </_StatBar>
            <_StatBar low>
              <span>Low</span>
              {
                insufficientPredictionData ?
                  <span>-</span>
                  :
                  <span><_BlurCont blur={!userIsAuthentificated}>${cn(prediction.min)}</_BlurCont></span>
              }
            </_StatBar>
          </div>
        </_EstimateRow>

        <ComparableArchivedListings
          latitude={Number(listing?.address?.lat)}
          longitude={Number(listing?.address?.lng)}
          listing={listing}
          offer={'Sale'}
          lowestAreaUrl={listing?.lowest_area?.url}
          seoText={`View recently sold nearby comparable listings for ${listing?.title}`}
        />

        {
          /*

          <div>
            <_SubsectionTitle>
              <h3>Market Insights</h3>
              <ToolTipV2
                title={'About Market Insights'}
                body={
                  `Market insights are based on recent sales over the past year within` +
                  ` a specific radius of this listing.`
                }
              />
            </_SubsectionTitle>


            {
              insufficientStatsData ?
              <>
                <_InsufficientDataCta>
                  <SvgIcon name="#icon-magnifying-glass" width={20} height={20} />
                  Insufficient local market data to provide market insights.
                  <AppButton
                    textClickableBtn
                    onClick={() => {
                      handleContactAgentClick(ctaSource, agent)
                    }}
                  >
                    Contact an agent
                  </AppButton>
                </_InsufficientDataCta>
                <_MobileAInsufficientDataContact
                  primary
                  medium
                  onClick={() => {
                    handleContactAgentClick(ctaSource, agent)
                  }}
                >
                  Contact an agent
                </_MobileAInsufficientDataContact>
              </>
              :
              <_AvgStats>

                <_AvgStatBlock>
                  <_StatBlockTitle>
                    Average Sold Price
                  </_StatBlockTitle>
                  <_StatBlockValue blur={!userIsAuthentificated}>
                    ${cn(avgClosedPrice)}
                  </_StatBlockValue>
                  <_StatBlockSubtitle>
                    Based on {totalListings} sales
                  </_StatBlockSubtitle>
                </_AvgStatBlock>

                <_AvgStatBlock>
                  <_StatBlockTitle>
                    Avg List/Sell Difference
                  </_StatBlockTitle>
                  <_StatBlockValue blur={!userIsAuthentificated} higher={avgListSellDiff > 0} lower={avgListSellDiff < 0}>
                    ${cn(Math.abs(avgListSellDiff))}
                  </_StatBlockValue>
                  <_StatBlockSubtitle>
                    {
                      !avgListSellDiffPercent ?
                      '-' :
                      `${Math.abs(avgListSellDiffPercent).toFixed(1)}% ${avgListSellDiffPercent > 0 ? 'above' : 'under'} list`
                    }
                  </_StatBlockSubtitle>
                </_AvgStatBlock>

                <_AvgStatBlock>
                  <_StatBlockTitle>
                    Avg days on market
                  </_StatBlockTitle>
                  <_StatBlockValue>
                    <_BlurCont blur={!userIsAuthentificated}>{avgDom.toFixed(0)}</_BlurCont>&nbsp;days
                  </_StatBlockValue>
                  <_StatBlockSubtitle>
                    Based on {totalListings} sales
                  </_StatBlockSubtitle>
                </_AvgStatBlock>

                <_AvgStatBlock>
                  <_StatBlockTitle>
                    Comparable Sold
                  </_StatBlockTitle>
                  <_StatBlockValue>
                    <_BlurCont blur={!userIsAuthentificated}>{totalListings}</_BlurCont>&nbsp;sold
                  </_StatBlockValue>
                  <_StatBlockSubtitle>
                    In last {totalDays} days
                  </_StatBlockSubtitle>
                </_AvgStatBlock>

              </_AvgStats>
            }

          </div>

          <Element id={navigationLinks.comparableSales}>
            <div>
              <_SubsectionTitle>
                <h3>Comparable Sales</h3>
                <ToolTipV2
                  title={'About Comparable Sales'}
                  body={
                    `Comparable Sales consists of listings with similar sqft, bed, bath,` +
                    ` and price sold over the past year within a specific radius of this listing.`
                  }
                />
              </_SubsectionTitle>

              {
                !listing?.comparables?.length ?
                <_InsufficientDataCta>
                  <SvgIcon name="#icon-magnifying-glass" width={20} height={20} />
                  No recently sold comparable properties nearby.
                  <AppButton
                    textClickableBtn
                    onClick={() => {
                      googleAnalyticsEvent({
                        category: 'listing',
                        action: [
                          'No Estimate comparables other areas click',
                        ],
                      })
                    }}
                    url={searchUrl}
                  >
                    Search another area
                  </AppButton>
                </_InsufficientDataCta>
                :
                <>
                  <_ComaparableCta>
                    <SvgIcon name="#icon-bright" width={20} height={20} />
                    {listing.title} is listed
                    <span>
                      <_BlurCont blur={!userIsAuthentificated}>
                        {priceDiffPercentage}%
                      </_BlurCont> {priceDiffPercentage > 0 ? 'higher' : 'lower'}
                    </span>
                    than nearby comparable sales.&nbsp;
                    <AppButton
                      textClickableBtn
                      onClick={() => {
                        handleBookViewing(ctaSource, agent)
                      }}
                    >
                      Request a viewing
                    </AppButton>
                  </_ComaparableCta>

                  <PreviewSliderSection
                    // mobileBrowser={mobileBrowser}
                    userIsAuthentificated={userIsAuthentificated}
                    listings={listing?.comparables}
                    maxListingCount={listing?.comparables?.length}
                    handleClick={() => {
                      googleAnalyticsEvent({
                        category: 'listing',
                        action: [
                          'listing card clicked from estimate comparables',
                        ],
                      })
                    }}
                    dataSource={'backend'}
                    gaCategory={'EstimateComparables'}
                    sourcePage={'listing'}
                    isMobileApp={isMobileApp}
                    estimateListing={listing}
                    // nearbyListingsOrSimilarListings
                  />
                </>
              }

            </div>
          </Element>
          */
        }
      </_EstimateContent>

    </Collapsible>
  )
}


ListingEstimate.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    lowest_area: PropTypes.shape({
      url: PropTypes.string,
    }),
    listing_estimate: PropTypes.shape({}),
    asking_price: PropTypes.number,
    address: PropTypes.shape({
      lat: PropTypes.string,
      lng: PropTypes.string,
    }),
  }),
  // makeItVisible: PropTypes.bool,
  // openCollapseTargetId: PropTypes.string,
  // collapseInputId: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
  // handleDemographicMapClick: PropTypes.func,
  collapsibleIdSuffix: PropTypes.string,
  places: PropTypes.shape({}),
  openLoginModal: PropTypes.func,
  openRegisterModal: PropTypes.func,
  // areasUrl: PropTypes.string,
  navigationLinks: PropTypes.shape({}),
  userIsAuthentificated: PropTypes.bool,
}

export default ListingEstimate
